import { render, staticRenderFns } from "./RegisterPharmacist.vue?vue&type=template&id=f88f2266&"
import script from "./RegisterPharmacist.vue?vue&type=script&lang=js&"
export * from "./RegisterPharmacist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports